"use client";

import { Button } from "@/components/shadcn/button";
import { Spinner } from "@/components/shadcn/spinner";
import { Link } from "@/i18n/navigation";
import { useSession } from "@/lib/auth/client";
import { Crown } from "lucide-react";
import { useTranslations } from "next-intl";
import { NavbarProfile } from "./navbar-profile";

export default function NavbarAuthControls() {
    const { data: session, isPending } = useSession();
    const t = useTranslations("nav");
    const isPremium = session?.user?.isPremium === true;

    if (isPending) {
        return (
            <div className="flex items-center gap-2">
                <Button
                    className="bg-foreground text-background hover:bg-foreground/90 relative"
                    disabled
                >
                    <Crown data-icon="inline-start" className="invisible" />
                    <span className="invisible hidden xl:inline">
                        {t("premiumOl")}
                    </span>
                    <Spinner className="absolute inset-0 m-auto" />
                </Button>

                <Button variant="outline" className="relative" disabled>
                    <span className="invisible">{t("login")}</span>
                    <Spinner className="absolute inset-0 m-auto" />
                </Button>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-2">
            <Button
                className="bg-foreground text-background hover:bg-foreground/90"
                asChild
            >
                <Link
                    href="/premium"
                    aria-label={isPremium ? t("premium") : t("premiumOl")}
                >
                    <Crown data-icon="inline-start" />
                    <span className="hidden xl:inline">
                        {isPremium ? t("premium") : t("premiumOl")}
                    </span>
                </Link>
            </Button>

            {session?.user ? (
                <NavbarProfile
                    user={{
                        name: session.user.name,
                        image: session.user.image,
                    }}
                    isPremium={isPremium}
                />
            ) : (
                <Button variant="outline" asChild>
                    <Link href="/login">{t("login")}</Link>
                </Button>
            )}
        </div>
    );
}
